/** My Library → Calendar (the posting calendar). */
export const CALENDAR_TEXT = {
  // What happens, in three steps (shown above the calendar)
  STEPS_TITLE: "How it works",
  STEP_PICK: "Fill picks clips from the videos you tick: free templates or AI picks.",
  STEP_CUT: "Each clip is cut right away in your style. You'll see Cutting…, then Ready.",
  stepPost: (privacy: string) =>
    `It posts by itself at its time through your Auto${privacy ? ` (${privacy === "public" ? "Public" : "Private"})` : ""}. Click a clip to watch it or take it off.`,
  PAUSE: "⏸ Pause posting",
  RESUME: "▶ Resume posting",
  PAUSE_TITLE: "Nothing posts while paused. A clip whose time passes while paused is skipped (its video stays in Exported).",
  PAUSED_NOTE: "⏸ Paused: nothing is posting. Clips whose time passes now are skipped.",
  CLEAR: "Take all off",
  clearConfirm: (n: number) => `Take all ${n} booked clips off the calendar? Their videos stay in Exported.`,
  CLEAR_ERROR: "Couldn't clear the calendar.",
  HOW_FAR: "3 · How far ahead",
  AHEAD: [
    { days: 1, label: "Next 24 hours" },
    { days: 3, label: "3 days" },
    { days: 7, label: "1 week" },
    { days: 14, label: "2 weeks" },
  ] as { days: number; label: string }[],
  DETAILS_TITLE: "This clip",
  CLOSE: "Close",
  TAKE_OFF: "Take it off the calendar",
  postsAt: (when: string) => `Posts ${when}`,
  WAITING_CUT: "It's being cut. You can watch it once it says Ready.",
  nextPost: (when: string) => ` · next post ${when}`,
  FROM: "from",
  PLAY: "▶ Play",
  PLAY_TITLE: "Watch the clip that will post",
  NOT_CUT_YET: "Being cut — you can play it once it's Ready",
  TIMES: "Posting times",
  ADD_TIME: "Add",
  removeTime: (time: string) => `Remove ${time}`,
  timezone: (tz: string) => `In your time zone (${tz}).`,
  summary: (booked: number, empty: number, days: number) =>
    `${booked} booked · ${empty} empty in the next ${days} days`,
  fill: (empty: number) => `📅 Fill ${empty} empty slot${empty === 1 ? "" : "s"}`,
  FILL_NONE: "Every slot is booked",
  NEEDS_AUTO: "Posts go out through Auto. Set it up first: your name (top right) → Account Settings → Auto.",
  PICK_VIDEOS: "1 · From which videos",
  SEARCH_VIDEOS: "Search your videos…",
  HOW: "2 · How to pick the clips",
  TEMPLATES: "Templates · free",
  AI: "AI scores · your own key",
  aiOnUs: (left: number | null) => (left === null ? "AI picks · on us" : `AI picks · on us (${left} left)`),
  AI_ON_US_NOTE: "Our AI reads every clip and picks the most shareable ones. Takes a minute or two.",
  AI_ON_US_NONE: "You've used this month's AI picks. Templates and your own key still work.",
  AI_RUNNING: "Picking the best clips with AI…",
  AI_NOTE: "Uses the Virality scores you made in the editor with your own AI key, highest first.",
  aiMissing: (title: string) => `"${title}" has no AI scores yet.`,
  OPEN_TO_SCORE: "Open it and press Score virality",
  AI_SCORED: "AI scores ✓",
  book: (n: number) => `Book up to ${n} clips`,
  bookAi: (n: number) => `🤖 Let AI pick up to ${n} clips`,
  BOOKING: "Booking…",
  CANCEL: "Cancel",
  PICK_A_VIDEO: "Tick at least one video.",
  EMPTY: "Empty",
  SKIP: "Take it off the calendar (the video stays in Exported)",
  STATE: {
    rendering: "Cutting…",
    ready: "Ready",
    posted: "✓ Posted",
    failed: "Didn't post",
    skipped: "Taken off",
    scheduled: "Booked",
  } as Record<string, string>,
  TODAY: "Today",
  TOMORROW: "Tomorrow",
  LOAD_ERROR: "Couldn't load your calendar.",
  SAVE_ERROR: "Couldn't save your posting times.",
  FILL_ERROR: "Couldn't fill the calendar.",
  clips: (n?: number) => (n ? `${n} clips` : ""),
} as const;

/** The free templates — transcript/shortlist.py RECIPES. */
export const CALENDAR_TEMPLATES = [
  { key: "longest_quotes", label: "Longest quotes" },
  { key: "positive", label: "All positive" },
  { key: "flagged", label: "Flagged moments" },
  { key: "highlights", label: "Highlights" },
] as const;
